import { filter, map, distinctUntilChanged } from 'rxjs/operators';
/**
 * @param {Observable<Concurrency>} concurrencyUpdate$
 * @returns {Observable<string>}
 */

const subscribeToConcurrencyUpdate = concurrencyUpdate$ =>
    concurrencyUpdate$
        .pipe(
            filter(concurrencyStore => concurrencyStore.partialServiceUrl),
            map(concurrencyStore => concurrencyStore.serviceUrl),
            distinctUntilChanged(),
        );

export default subscribeToConcurrencyUpdate;

